/* lua.js generated code undefined */

const Event = require("cocos/framework/components/event")
DAManagerGUILogger = xClass("DAManagerGUILogger", Event)
let _instance = null
DAManagerGUILogger.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DAManagerGUILogger.new()
    }
    return _instance
}
DAManagerGUILogger.prototype.ctor = function () {
    let self = this
    self.reset()
}
DAManagerGUILogger.prototype.reset = function () {
    let self = this
    self._logStr = ""
}
DAManagerGUILogger.prototype.showLoggerInGameScene = function (levelInfoStr) {
    // let self = this
    // if ($len(self._logStr) <= 0) {
    //     self._logStr = levelInfoStr
    // }
    // self._removeLogger()
    // self._showLoggerInGameScene = true
    // self.updateLoggerInGameScene()
}
DAManagerGUILogger.prototype.updateLoggerInGameScene = function () {
    // let self = this
    // if (!self._showLoggerInGameScene) {
    //     return 
    // }
    // let width = 600
    // let height = 300
    // let padding = 10
    // if (!self.logLayer || tolua.isnull(self.logLayer)) {
    //     let scene = cc.Director.getInstance().getRunningScene()
    //     let max = 70
    //     let layer = cc.LayerColor.create(cc.c4b(0, 0, 0, 220), width, height)
    //     layer.setPosition((display.width - width) / 2, display.height - height)
    //     scene.addChild(layer, 999999)
    //     self.logLayer = layer
    //     let sprite = UnionUIHelper.createSprite("uilibrary/off_btn_light.png", width - 30, height - 30, 2, null)
    //     layer.addChild(sprite, 10)
    //     let button = UIButton.create(sprite, true)
    //     button.on(UIButtonEvent.Click, function () {
    //         self._removeLogger()
    //     })
    //     PushBounceAnim.create(button)
    //     let scrollView = ccui.ScrollView.create()
    //     scrollView.setTouchEnabled(true)
    //     scrollView.setContentSize(cc.size(width, height))
    //     scrollView.setClippingType(1)
    //     scrollView.setBounceEnabled(true)
    //     scrollView.setDirection(ccui.ScrollViewDir.vertical)
    //     layer.addChild(scrollView)
    //     let label = cc.Label.createWithSystemFont("", "Arial", 25)
    //     label.setAnchorPoint(ccp(0, 1))
    //     label.setPosition(ccp(padding, height))
    //     label.setWidth(width - padding * 2)
    //     label.setColor(cc.c4b(249, 161, 1, 255))
    //     scrollView.getInnerContainer().addChild(label)
    //     self.logLabel = label
    //     self.logLabel.scrollView = scrollView
    // }
    // if (self.logLabel && !tolua.isnull(self.logLabel)) {
    //     self.logLabel.setString(self._logStr)
    //     let size = self.logLabel.getContentSize()
    //     let contentHeight = Math.max(size.height, height)
    //     self.logLabel.setPosition(ccp(padding, contentHeight))
    //     self.logLabel.scrollView.setInnerContainerSize(cc.size(width, contentHeight))
    //     self.logLabel.scrollView.scrollToBottom(0.2, false)
    // }
}
DAManagerGUILogger.prototype._removeLogger = function () {
    // let self = this
    // if (self.logLabel && !tolua.isnull(self.logLabel)) {
    //     self.logLabel.removeFromParent(true)
    //     self.logLabel = null
    // }
    // if (self.logLayer && !tolua.isnull(self.logLayer)) {
    //     self.logLayer.removeFromParent(true)
    //     self.logLayer = null
    // }
    // self._showLoggerInGameScene = false
}
DAManagerGUILogger.prototype.print = function (appendStr) {
    let self = this
    self._logStr = self._logStr + "\n" + appendStr
    // self.updateLoggerInGameScene()
    // console.log("特殊" +self._logStr);
    console.log(appendStr);
}
